'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liveVideoDetail = exports.liveVideos = exports.videoCompletedViews = exports.videoTracking = exports.videoViewRatings = exports.videosFilters = exports.videoBookmarks = exports.videoDetails = exports.videoStacks = exports.videoCollection = exports.onDemandVideos = exports.videos = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sagaTools = require('@classpass/saga-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var videos = exports.videos = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEOS', function (client, filters) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { brackets: true };
  return client.videos.getVideosList(filters, options);
}); /* eslint-disable import/prefer-default-export */

var onDemandVideos = exports.onDemandVideos = (0, _sagaTools.makeEntityScaffold)('SAGA.API.ON_DEMAND_VIDEOS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return client.videos.getOnDemandVideos(options);
});

var videoCollection = exports.videoCollection = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEO_COLLECTION', function (client, collectionType, collectionName, flags) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return client.videos.getCollectionsByName(collectionType, collectionName, flags, options);
});

var videoStacks = exports.videoStacks = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEO_STACKS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (
    // Massage cards data to match video details
    client.videos.getStacks(options).then(function (res) {
      return res.stacks.map(function (stack) {
        return (0, _extends3.default)({}, stack, {
          cards: stack.cards.map(function (card) {
            card.instructor = card.subtitle || card.instructor;
            card.thumbnail_large_url = card.image_path;
            card.partner = { alias: card.partner_alias };
            return card;
          })
        });
      });
    })
  );
});

var videoDetails = exports.videoDetails = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEO_DETAILS', function (client, partnerAlias, videoAlias) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return client.videos.getVideoIdByLookup({
    partner_alias: partnerAlias,
    video_alias: videoAlias
  }, options).then(function (lookup) {
    return client.videos.getVideoById(lookup.id, { cp_home_beta: true }).then(function (data) {
      var streamUrl = data.stream_url || 'https://player.ooyala.com/player/appletv/' + data.content_id + '.m3u8';
      return (0, _extends3.default)({}, data, {
        stream_url: streamUrl
      });
    });
  });
}, { defaultKey: 2 });

var videoBookmarks = exports.videoBookmarks = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEO_BOOKMARKS', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.videos.getUserVideoBookmarks(userId, options);
});

var videosFilters = exports.videosFilters = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEO_FILTERS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { app: 'web' };
  return client.videos.getVideosFilters(options);
});

var videoViewRatings = exports.videoViewRatings = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEO_VIEW_RATINGS', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.videos.getVideoViewRatings(userId, { ratings_type: 'pending' }, options);
});

var videoTracking = exports.videoTracking = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEO_TRACKING', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.videos.videoEvents(userId, options).then(function (data) {
    return (0, _extends3.default)({ video_id: options.video_id }, data);
  });
});

var videoCompletedViews = exports.videoCompletedViews = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VIDEO_COMPLETED_VIEWS', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { view_type: 'completed' };
  return client.videos.getViewedVideos(userId, options);
});

var liveVideos = exports.liveVideos = (0, _sagaTools.makeEntityScaffold)('SAGA.API.LIVE_VIDEOS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return client.videos.getLiveVideos(options);
});

var liveVideoDetail = exports.liveVideoDetail = (0, _sagaTools.makeEntityScaffold)('SAGA.API.LIVE_VIDEO_DETAILS', function (client, alias) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.videos.getLiveVideosById(alias, options);
}, { defaultKey: 1 });